module.exports = __webpack_public_path__ + "img/default.8eb0e314.png";